import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Navbar from '../components/Navbar'
import './all.sass'


const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet title="Rooter Help" />
    <Helmet>
      <link rel="shortcut icon" href="/favicon.ico" />
    </Helmet>
    <Navbar />
    <div>{children()}</div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js